import { render } from "./ControlPanelVoicemail.vue?vue&type=template&id=6b3db732&scoped=true"
import script from "./ControlPanelVoicemail.vue?vue&type=script&lang=js"
export * from "./ControlPanelVoicemail.vue?vue&type=script&lang=js"

import "./ControlPanelVoicemail.vue?vue&type=style&index=0&id=6b3db732&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3db732"]])

export default __exports__